export default __webpack_public_path__ + "static/media/carousel2.cac4200c.jpeg";